module.exports = __webpack_public_path__ + "static/media/Urinere.e68908b3.m4a";